import React from "react";
import { Link } from "react-router-dom";
import { ImageIcon, Github, Twitter } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function Footer() {
  const { t } = useI18n();
  const y = new Date().getFullYear();
  return (
    <footer className="mt-24 border-t border-slate-200 dark:border-white/10 bg-slate-50 dark:bg-[#0b0c0e]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-lg bg-blue-600 grid place-items-center text-white">
              <ImageIcon size={18} strokeWidth={2.5} />
            </div>
            <span className="font-semibold text-lg tracking-tight text-slate-900 dark:text-white">
              ImageKit<span className="text-blue-600 dark:text-blue-400">Hub</span>
            </span>
          </Link>
          <p className="mt-4 text-sm text-slate-500 dark:text-slate-400 max-w-xs leading-relaxed">{t("footer.tagline")}</p>
          <div className="flex items-center gap-3 mt-6">
            <a href="#" aria-label="Twitter" className="p-2 rounded-lg border border-slate-200 dark:border-white/10 text-slate-500 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"><Twitter size={16} /></a>
            <a href="#" aria-label="Github" className="p-2 rounded-lg border border-slate-200 dark:border-white/10 text-slate-500 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"><Github size={16} /></a>
          </div>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-widest text-blue-600 dark:text-blue-400 mb-4">{t("footer.product")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white" to="/tools">{t("footer.all_tools")}</Link></li>
            <li><Link className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white" to="/tools/image-compressor">Compressor</Link></li>
            <li><Link className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white" to="/tools/batch-compressor">Batch Compress</Link></li>
            <li><Link className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white" to="/favorites">{t("nav.favorites")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-widest text-blue-600 dark:text-blue-400 mb-4">{t("footer.company")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white" to="/about">{t("nav.about")}</Link></li>
            <li><Link className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white" to="/contact">{t("nav.contact")}</Link></li>
            <li><Link className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white" to="/blog">{t("nav.blog")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs font-semibold uppercase tracking-widest text-blue-600 dark:text-blue-400 mb-4">{t("footer.legal")}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white" to="/privacy">{t("footer.privacy")}</Link></li>
            <li><Link className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white" to="/terms">{t("footer.terms")}</Link></li>
            <li><Link className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white" to="/cookies">{t("footer.cookies")}</Link></li>
            <li><Link className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white" to="/dmca">{t("footer.dmca")}</Link></li>
            <li><Link className="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white" to="/disclaimer">{t("footer.disclaimer")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 dark:border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-slate-500 dark:text-slate-500 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p>© {y} ImageKitHub. {t("footer.copyright")}</p>
          <p>{t("footer.built")}</p>
        </div>
      </div>
    </footer>
  );
}
